import { ReactComponent as CopyIconGray } from 'assets/icons/CopyIconGray.svg';
import { ReactComponent as PreviewIconGray } from 'assets/icons/PreviewIconGray.svg';
import styled from "styled-components";

export const Wrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
  width: 500px;
  color: var(--dark-blue, #002E5C);
  font-family: var(--EventsWrapperFont-family);

`

export const Contant = styled.div`
width: 85%;
height: 100%;
padding-top: 30px;
`
export const Header = styled.div`
width: 100%;
display: flex;
justify-content: space-between;
font-size: 20px;
font-weight: 600;

`
export const Dates = styled.div`
width: 100%;
display: flex;
justify-content: space-between;
padding-top: 30px;
div{
display: flex;
flex-direction: column;
justify-content: flex-start;
span{
    color: #002E5C;
    font-weight: 400;
    font-size: 14px;
    opacity: 0.7;
   
}
p{
    color: var(--dark-blue, #002E5C);
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: 16px;
    font-weight: bold;
    line-height: 40.348px;

}
:nth-child(3) {
    p{
    :hover{
        text-decoration: underline;
            } 
    }
}
}
`
export const PreviewIcon=styled(PreviewIconGray)`
    margin-left: 7px;
    margin-top: -3px;
`
export const EventType=styled.div`
border-radius: 4px;
padding: 10px 0px;
border: 1px solid rgba(0, 46, 92, 0.10);
display: flex;
justify-content: space-between;
gap: 10px;
padding-top: 20px;
padding-left: 15px;
padding-bottom: 20px;
margin-top: 17px;
div:nth-child(1){
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-right: 10px;
    border-right: 1px solid rgba(0, 46, 92, 0.10);
    span{
        color: var(--blue, #2555EF);
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        /* line-height: 32px; */
        
    }
    span:nth-child(2){               
        font-size: 12px;
        color: #002E5C;
        line-height: normal;
        opacity: 0.7;
    }
}
div:nth-child(2){
            color: #002E5C;
            font-size: 12px;
            font-weight: bold;
            margin-right: 60px;
            span{
                color: #002E5C;
                opacity: 0.7;
                font-size: 12px;
                font-weight: 400;
                padding-right: 5px;

            }
            span:nth-child(2){               
                     padding-left: 8px;
            }
div:nth-child(1){
        border-right: 0;
        display: flex;
        align-items: flex-start;
        flex-direction: row;
        gap: 8px;
        width: auto;
        span{ color: #002E5C;
                opacity: 0.7;
                font-size: 12px;
                font-weight: 400}

    }


}
`
export const VirtualAddress = styled.div`
   line-height: normal;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        padding-top: 15px;
`
export const CopyIcon = styled(CopyIconGray)`
    margin-left: 7px;
    margin-top: -3px;
`
export const Buttons=styled.div`
display: flex;
justify-content: space-between;
width: 100%;
padding-top: 28px;
padding-bottom: 10px;
`
export const Button=styled.button`
background-color: transparent;
display: flex;
justify-content: center;
align-items: center;
width: 200px;
height: 44px;
padding: 8px 20px;
border: 1px dashed rgba(0, 46, 92, 0.20);
border-radius: 5px;
font-size: 12px;
line-height: 32px;
font-weight: 500;
span{
    padding-left: 5px;
}
`
export const Description = styled.div`
span{
    color: #002E5C;
    opacity: 0.7;
font-family: var(--EventsDescriptionSpanFont-family);
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
}
p{
    color: var(--dark-blue, #002E5C);
font-feature-settings: 'clig' off, 'liga' off;
font-family: var(--EventsDescriptionPFont-family);
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 26.348px; /* 164.674% */
}

`
export const Worning = styled.div`
display: flex;
padding: 10px 0px;
flex-direction: column;
align-items: flex-start;
gap: 10px;
align-self: stretch;
display: flex;
justify-content: flex-start;
flex-direction: row;
span{
color: var(--error, #F1585E);
font-family: var(--EventsWorningSpanFont-family);
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: normal;
}
margin-bottom: 21px;
`
export const PriceSection = styled.div`
font-family: var(--GeneralPriceSectionFont-family);
font-style: normal;
display: flex;
flex-direction: column;
align-items: flex-start;
color: var(--dark-blue, #002E5C);
div{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    line-height: normal;
    width: 100%;
    padding: 10px;
}

& .price_section-optional {
    margin: 0 0.5rem;
    color: rgb(0, 46, 92, 0.6);
    font-size: 12px;
}

`
export const Total = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #e5e5ea;
    padding-top: 12px;
    margin-top: 22px;
  

    p{
       
       font-family: var(--EventsTotalPFont-family);
       font-size: 16px;
       font-style: normal;
       font-weight: 400; 
       line-height: normal;
       text-transform: capitalize;
       }
       span{
       font-family: var(--EventsTotalSpanFont-family);
       font-size: 16px;
       font-style: normal;
       font-weight: 700;
       line-height: normal;
       text-transform: capitalize; 
       }

`